module.exports = __webpack_public_path__ + "static/media/passo7.719e1a2f.jpg";